module.exports = __webpack_public_path__ + "static/media/userActive.fd9ae18d.svg";